module.exports = {
      id: "icons:share-usage",
      viewBox: "0 0 16 14",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:share-usage",
      toString: function () {
        return this.url;
      }
    }